<style>
.filter-label {
  margin-top: 5px;
}
</style>
<template>
  <div>
    <b-card class="mb-0">
      <b-row>
        <b-col cols="12">
          <div class="d-flex justify-content-end">
            <b-button variant="primary" to="/inventory-transactions/add">
              <feather-icon icon="PlusIcon" class="mr-50" />
              Add Transaction
            </b-button>
          </div>
        </b-col>
        <b-col md="2" sm="4" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
          </b-form-group>
        </b-col>
        <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
          <b-button variant="outline-danger" size="sm" @click="clearFilters">
            Clear Filters
          </b-button>
        </b-col>
        <b-col cols="12">
          <b-table striped hover responsive :per-page="perPage" :current-page="currentPage"
            :items="filteredTransactions" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection" @filtered="onFiltered">

            <!-- Filter input for Type -->
            <template #head(type)>
              <div class="d-flex flex-column">
                <span>Type</span>
                <b-form-select v-model="filters.type" :options="[{ value: null, text: 'All' }, ...types]" size="sm"
                  @change="filterTable" />
              </div>
            </template>

            <!-- Filter input for From Warehouse -->
            <template #head(fromWarehouse)>
              <div class="d-flex flex-column">
                <span>From Warehouse</span>
                <b-form-input v-model="filters.fromWarehouse" placeholder="Filter by From Warehouse" size="sm"
                  @input="filterTable" />
              </div>
            </template>

            <!-- Filter input for To Warehouse -->
            <template #head(toWarehouse)>
              <div class="d-flex flex-column">
                <span>To Warehouse</span>
                <b-form-input v-model="filters.toWarehouse" placeholder="Filter by To Warehouse" size="sm"
                  @input="filterTable" />
              </div>
            </template>

            <!-- Filter input for Date -->
            <template #head(date)>
              <div class="d-flex flex-column">
                <span>Date</span>
                <DatePicker v-model="filters.dateRange" range placeholder="Select Date Range" size="sm"
                  @change="filterTable" :clearable="false" :input-attr="{ readonly: true }" @focus="openCalendar"
                  class="small-datepicker" />
              </div>
            </template>

            <!-- Filter input for Posted -->
            <template #head(posted)>
              <div class="d-flex flex-column">
                <span>Posted</span>
                <b-form-select v-model="filters.posted"
                  :options="[{ value: null, text: 'All' }, { value: true, text: 'Posted' }, { value: false, text: 'Open' }]"
                  size="sm" @change="filterTable" />
              </div>
            </template>

            <template #cell(type)="data">
              {{ getTypeNameById(data.value) }}
            </template>
            <template #cell(fromWarehouse)="data">
              {{ getWarehouseNameById(data.value) }}
            </template>
            <template #cell(toWarehouse)="data">
              {{ getWarehouseNameById(data.value) }}
            </template>
            <template #cell(posted)="data">
              <b-badge v-if="data.value === true" variant="primary">
                Posted
              </b-badge>
              <b-badge v-else variant="secondary"> Open </b-badge>
            </template>
            <template #cell(date)="data">
              {{ dayjs(data.value).format("DD/MM/YYYY hh:mm:ss") }}
            </template>
            <template #cell(actions)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template v-slot:button-content>
                  <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                </template>
                <b-dropdown-item v-b-modal.modal-edit :to="getTransactionView(data.item.id)">
                  <feather-icon icon="EyeIcon" class="mr-50" />
                  <span>View</span>
                </b-dropdown-item>
                <!-- <b-dropdown-item
                  v-b-modal.modal-edit
                  :to="getTransactionEdit(data.item.id)"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Edit</span>
                </b-dropdown-item> -->
                <b-dropdown-item v-if="!data.item.posted" @click="removeTransaction(data.item.id)">
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner variant="success" label="Spinning" block v-if="loading || warehouseLoading"
              style="width: 3rem; height: 3rem"></b-spinner>
          </div>
        </b-col>

        <b-col cols="12">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
            class="my-0" />
          <b-form-group>
            Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BTabs,
  BTab,
  BCardImg,
  BCardFooter,
  BFormGroup,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BSpinner,
} from "bootstrap-vue";

import { mapActions, mapGetters } from "vuex";
import dayjs from "dayjs";
import Datepicker from "vue2-datepicker";

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BCardImg,
    BCardFooter,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BInputGroupAppend,
    BPagination,
    BSpinner,
    DatePicker
  },
  data() {
    return {
      dayjs,
      perPage: 5,
      pageOptions: [5, 10, 15, 20],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      filters: {
        type: null,
        fromWarehouse: "",
        toWarehouse: "",
        dateRange: null,
        posted: null,
      },
      filteredTransactions: [],
      fields: [
        { key: "type", sortable: true },
        { key: "fromWarehouse", sortable: true },
        { key: "toWarehouse", sortable: true },
        { key: "date", sortable: true },
        { key: "posted", sortable: true },
        { key: "actions" } // Actions typically aren't sortable
      ],
      types: [
        { value: 1, text: "PURCHASE" },
        { value: 2, text: "PRODUCTION" },
        { value: 3, text: "SALES" },
        { value: 4, text: "RETURN" },
        { value: 5, text: "DEFECT" },
        { value: 6, text: "LOST" },
        { value: 7, text: "STOLEN" },
        { value: 8, text: "TRANSFER" },
      ],
    };
  },
  methods: {
    ...mapActions("inventoryTransactionModule", [
      "getTransactionListAction",
      "removeTransactionAction",
    ]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getTransactionView(item) {
      return "/inventory-transactions/view/" + item;
    },
    getTransactionEdit(item) {
      return "/inventory-transactions/edit/" + item;
    },
    removeTransaction(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeTransactionAction(id);
          this.$swal({
            icon: "success",
            title: "Deleted",
            text: "Transaction has been deleted successfully!",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    getTypeNameById(id) {
      let type = this.types.filter((x) => {
        return x.value === id;
      });
      if (type.length > 0) return type[0].text;
      else return id;
    },
    getWarehouseNameById(id) {
      let warehouse = this.warehouses.filter((x) => {
        return x.id === id;
      });
      if (warehouse.length > 0) return warehouse[0].name;
      else return id;
    },
    filterTable() {
      this.filteredTransactions = this.transactions.filter((transaction) => {
        // Type filter
        const matchesType = this.filters.type !== null
          ? transaction.type === this.filters.type
          : true;

        // From Warehouse filter (using warehouse name)
        const fromWarehouseName = this.getWarehouseNameById(transaction.fromWarehouse);
        const matchesFromWarehouse = this.filters.fromWarehouse
          ? fromWarehouseName &&
          fromWarehouseName
            .toString()
            .toLowerCase()
            .includes(this.filters.fromWarehouse.toLowerCase())
          : true;

        // To Warehouse filter (using warehouse name)
        const toWarehouseName = this.getWarehouseNameById(transaction.toWarehouse);
        const matchesToWarehouse = this.filters.toWarehouse
          ? toWarehouseName &&
          toWarehouseName
            .toString()
            .toLowerCase()
            .includes(this.filters.toWarehouse.toLowerCase())
          : true;

        // Date range filter
        const matchesDate =
          this.filters.dateRange && this.filters.dateRange.length === 2
            ? dayjs(transaction.date).isAfter(this.filters.dateRange[0]) &&
            dayjs(transaction.date).isBefore(this.filters.dateRange[1])
            : true;

        // Posted filter
        const matchesPosted =
          this.filters.posted !== null
            ? transaction.posted === this.filters.posted
            : true;

        return (
          matchesType &&
          matchesFromWarehouse &&
          matchesToWarehouse &&
          matchesDate &&
          matchesPosted
        );
      });

      this.totalRows = this.filteredTransactions.length;
      this.currentPage = 1;
    },
    openCalendar(event) {
      event.target.blur();
      event.target.click();

      document.addEventListener('click', this.closeCalendar);
    },
    closeCalendar(event) {
      const datePicker = this.$refs.datePicker.$el;
      if (!datePicker.contains(event.target)) {
        this.$refs.datePicker.hideCalendar();

        document.removeEventListener('click', this.closeCalendar);
      }
    },
    clearFilters() {
      // Reset all filter values
      this.filters = {
        type: null,
        fromWarehouse: "",
        toWarehouse: "",
        dateRange: null,
        posted: null,
      };

      // Reset filtered data to the original transactions
      this.filteredTransactions = [...this.transactions];
      this.totalRows = this.filteredTransactions.length;
      this.currentPage = 1; // Reset pagination to the first page
    }

  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("inventoryTransactionModule", {
      transactions: "transactions",
      loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),
  },
  async mounted() {
    await this.getWarehouseListAction();
    await this.getTransactionListAction().then(() => {
      this.totalRows = this.transactions.length;
      this.filteredTransactions = [...this.transactions]; // Make sure filteredTransactions has data
    });
  },
};
</script>